<p [ngClass]="status">{{status}}</p>
